import React from 'react';

const ShowUnit = ({unit}) => (
    <span style={{fontWeight: "normal", fontSize: "0.8em"}}>({unit})</span>
)

export { ShowUnit }
